<template>
  <div>
    <div class="wc-row">
      <div class="wc-col">
        <MotorCockpit
          :change-type="changeType"
          :partner-proxy-id="partnerProxyId"
        ></MotorCockpit>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getPartnerProxyId } from '@/utils/KeycloakUtils'
import { onBeforeMount, onMounted, type Ref, ref } from 'vue'
import MotorCockpit from '@/componentsTenant/motor/cockpit/MotorCockpit.vue'

enum MotorCockpitEnum {
  Default,
  Fahrleistung,
  Versicherungsumfang,
  Fahrerkreis
}

const changeType = ref('')

const partnerProxyId: Ref<string> = ref('')

onBeforeMount(() => {
  partnerProxyId.value = retrievePartnerProxyId()
})

onMounted(() => {
  for (const item in MotorCockpitEnum) {
    // Sicherstellen, dass item ein String ist und keine Zahl (Enum reverse mapping)
    if (isNaN(Number(item))) {
      if (
        globalThis.location.pathname.includes(
          `${globalThis.ENV_CONFIG?.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.ROOT}/motor-cockpit-${item.toLowerCase()}`
        )
      ) {
        if (item && item.length > 0) {
          changeType.value = 'Change' + item[0]!.toUpperCase() + item.slice(1)
        }
      }
    }
  }
})
function retrievePartnerProxyId(): string {
  const partnerProxyId = getPartnerProxyId()
  if (!partnerProxyId) {
    throw new Error('No partner proxy id available!')
  }
  return partnerProxyId
}
</script>

<style lang="scss" scoped>
.mb {
  margin-bottom: 1rem;
}

.done {
  text-decoration: line-through;
}
</style>
